<template>
    <b-card class="mb-5">
        <b-row>
            <b-col md="6">
                <h3>{{$route.name}}</h3>
                <b-breadcrumb>
                <b-breadcrumb-item><router-link to="/dashboard">Dashboard</router-link></b-breadcrumb-item>
                <b-breadcrumb-item><router-link to="/purchase-requisition">Purchase Requisition</router-link></b-breadcrumb-item>
                <b-breadcrumb-item active>{{ $route.name }}</b-breadcrumb-item>
                </b-breadcrumb>
            </b-col>
            <b-col md="6" class="text-right mt-3" v-if="model.status === 'Requested'">
                <b-button v-if="$store.getters['account/accountData'].uuid === model.nextApproval" variant="danger" class="btn-sm mr-2" @click="showModal('reject')">
                    <font-awesome-icon icon="times-circle"></font-awesome-icon> Reject
                </b-button>
                <b-button v-if="$store.getters['account/accountData'].uuid === model.nextApproval" variant="success" class="btn-sm mr-1" @click="showModal('approve')">
                    <font-awesome-icon icon="check-circle"></font-awesome-icon> Update & Approve
                </b-button>
            </b-col>
        </b-row>
        <div class="border-bottom mb-3"/>
        <template v-if="isLoading">
            <div class="d-flex justify-content-center mb-5 mt-5 pt-5 pb-5">
                <b-spinner style="width: 3rem; height: 3rem;" variant="primary" label="Loading..."></b-spinner>
            </div>
        </template>
        <b-form class="mt-4 mx-2" v-else>
            <b-row>
                <b-col md="6 mb-3">
                    <b-row>
                        <b-col md="4">
                            <label class="labels">Requested By</label>
                        </b-col>
                        <b-col md="8">
                            <p>{{ model.requestedBy }}</p>
                        </b-col>
                    </b-row>
                    <b-row>
                        <b-col md="4">
                            <label class="labels">Created</label>
                        </b-col>
                        <b-col md="8">
                            <p>{{ model.createdAt }}</p>
                        </b-col>
                    </b-row>
                    <b-row>
                        <b-col md="4">
                            <label class="labels">Item Name</label>
                        </b-col>
                        <b-col md="8">
                            <p>{{ model.name }}</p>
                        </b-col>
                    </b-row>
                    <b-row>
                        <b-col md="4">
                            <label class="labels">Price</label>
                        </b-col>
                        <b-col md="5">
                            <div v-if="!model.editing">
                                <span class='text'>{{ dataAccount.account.currency }} {{ formatPrice(model.price) }}</span>
                            </div>
                            <div v-if="model.editing">
                                <input class="input form-control" type="number" v-model="model.priceTemp"/>
                            </div>
                        </b-col>
                        <b-col md="3">
                            <div v-if="model.editing">
                                <b-button v-b-tooltip.hover.top title="Cancel" size="sm" id="btn-size" @click="disableEditing"><font-awesome-icon icon="times-circle"></font-awesome-icon></b-button>
                                <b-button v-b-tooltip.hover.top title="Update" id="btn-size" class="ml-1" variant="warning" size="sm" @click="saveEdit()"><font-awesome-icon icon="save"></font-awesome-icon></b-button>
                            </div>
                            <div v-else>
                                <b-button v-if="$store.getters['account/accountData'].uuid === model.nextApproval && model.status === 'Requested'" variant="warning" v-b-tooltip.hover.top title="Edit Price" size="sm" id="btn-edit" @click="enableEditing"><font-awesome-icon icon="pencil-alt"></font-awesome-icon></b-button>
                            </div>
                        </b-col>
                        <!-- <b-col md="8">
                            <p>{{ dataAccount.account.currency }} {{ formatPrice(model.price) }}</p>
                        </b-col> -->
                    </b-row>
                </b-col>
                <b-col md="6">
                    <b-row>
                        <b-col md="4">
                            <label class="labels">Note</label>
                        </b-col>
                        <b-col md="8">
                            <p>{{ model.note }}</p>
                        </b-col>
                    </b-row>
                    <b-row>
                        <b-col md="4">
                            <label class="labels">Status</label>
                        </b-col>
                        <b-col md="8">
                            <p><b-badge :variant="getStatusColor(model.status)">{{model.status}}</b-badge></p>
                        </b-col>
                    </b-row>
                    <b-row v-if="model.statusValue !== ''">
                        <b-col md="4">
                            <label class="labels">{{model.statusText}}</label>
                        </b-col>
                        <b-col md="8">
                            <p>{{ model.statusValue }}</p>
                        </b-col>
                    </b-row>
                    <b-row v-if="model.statusTime !== ''">
                        <b-col md="4">
                            <label class="labels">{{model.statusTextTime}}</label>
                        </b-col>
                        <b-col md="8">
                            <p>{{ model.statusTime }}</p>
                        </b-col>
                    </b-row>
                    <b-row>
                        <b-col md="4">
                            <label class="labels">Last Approval By</label>
                        </b-col>
                        <b-col md="8">
                            <p>{{ model.lastApproval }}</p>
                        </b-col>
                    </b-row>
                </b-col>
            </b-row>
            <b-row>
                <b-col>
                    <h5 class="mb-3 mt-4">Purchase Requisition Status History</h5>
                </b-col>
                <b-col md="12">
                    <div class="table-responsive">
                    <table class="table table-hovered table-striped">
                        <thead>
                            <tr>
                                <th scope="col" width="100">Status</th>
                                <th scope="col" width="250">Changed By</th>
                                <th scope="col" width="150">Position</th>
                                <th scope="col">Note</th>
                                <th scope="col" width="200">Time</th>
                            </tr>
                        </thead>
                        <tbody v-if="purchaseRequisitionHistoryStatusList.length > 0">
                        <tr v-for="purchaseRequisition in purchaseRequisitionHistoryStatusList" :key="purchaseRequisition.uuid">
                            <td><b-badge :variant="getStatusColor(purchaseRequisition.status)">{{purchaseRequisition.status}}</b-badge></td>
                            <td>{{purchaseRequisition.changedBy !== null ? purchaseRequisition.changedBy : '-'}}</td>
                            <td>{{purchaseRequisition.position !== null ? purchaseRequisition.position : '-'}}</td>
                            <td>
                                <div :id="'tooltip-button-' + purchaseRequisition.uuid">
                                    {{purchaseRequisition.note !== null ? purchaseRequisition.note.substring(0, 30) : '-'}}
                                    {{purchaseRequisition.note !== null && purchaseRequisition.note.length >= 30 ? '...' : ''}}
                                </div>
                                <b-tooltip v-if="purchaseRequisition.note !== null && purchaseRequisition.note.length >= 30" :target="'tooltip-button-' + purchaseRequisition.uuid" placement="bottom">
                                    {{purchaseRequisition.note}}
                                </b-tooltip>
                            </td>
                            <td>{{purchaseRequisition.createdAt !== null ? getDateTime(purchaseRequisition.createdAt) : '-'}}</td>
                        </tr>
                        </tbody>
                        <tbody v-else>
                        <tr>
                            <td colspan="9" class="text-center">There's no data</td>
                        </tr>
                        </tbody>
                    </table>
                    </div>
                </b-col>
            </b-row>
        </b-form>
        <b-modal id="bv-modal-example" hide-footer>
            <template v-slot:modal-title>
                <h5 class="text-transform">{{type}} Purchase Requisition</h5>
            </template>
            <form v-on:submit.prevent="doChangeStatus(type)">
                <div class="d-block">
                    <!-- <div v-if="this.type === 'approve'">
                        <label for="" class="labels">Price</label>
                        <b-form-input type="number" v-model="formData.price" placeholder="Enter Price"></b-form-input><br>
                    </div> -->
                    <label for="" class="labels">Note</label>
                    <b-form-textarea rows="3" v-model="formData.note" placeholder="Enter Note"></b-form-textarea>
                </div>
                <b-button class="mt-4" @click="$bvModal.hide('bv-modal-example')"><font-awesome-icon icon="times"></font-awesome-icon> Cancel</b-button>
                <b-button variant="primary" type="submit" class="mt-4 float-right"><font-awesome-icon icon="spinner" spin v-if="isLoading"></font-awesome-icon> <font-awesome-icon icon="save" v-else></font-awesome-icon> Submit</b-button>
            </form>
        </b-modal>
        <b-button class="mt-3" @click="goBack" variant="secondary"><font-awesome-icon icon="chevron-circle-left"></font-awesome-icon> Back</b-button>
    </b-card>
</template>

<script>

    export default {
        name: 'purchase-requisition-show',
        data () {
            return {
                isLoading: false,
                dataAccount: this.$store.getters['account/accountData'],
                apiUrl: {
                    purchaseRequisition: window.AppConfig.apiUrl + 'purchase-requisition'
                },
                type: null,
                formData: {
                    note: null,
                    price: null
                },
                model: {
                    editing: false,
                    name: '',
                    price: '',
                    priceTemp: '',
                    requestedBy: '',
                    lastApproval: '',
                    createdAt: '',
                    position: '',
                    nextApproval: '',
                    note: '',
                    status: '',
                    statusValue: '',
                    statusText: '',
                    statusTime: '',
                    statusTextTime: ''
                },
                purchaseRequisitionHistoryStatusList: []
            }
        },
        mounted () {
            this.getDetail()
        },
        methods: {
            getDetail () {
                this.isLoading = true
                this.$http.get(this.apiUrl.purchaseRequisition + '/' + this.$route.params.uuid)
                .then(response => {
                    this.isLoading = false
                    this.model.name = response.data.name !== null ? response.data.name : '-'
                    this.model.requestedBy = response.data.requestedBy !== null ? response.data.requestedBy.name : '-'
                    this.model.status = response.data.status !== null ? response.data.status : '-'
                    this.model.note = response.data.note !== null ? response.data.note : '-'
                    this.model.price = response.data.price !== null ? response.data.price : '-'
                    this.model.nextApproval = response.data.nextApproval !== null ? response.data.nextApproval : '-'
                    this.model.position = response.data.position !== null ? response.data.position : '-'
                    this.model.lastApproval = response.data.lastApproval !== null ? response.data.lastApproval : '-'
                    this.model.createdAt = response.data.createdAt !== null ? this.$moment(response.data.createdAt).format('YYYY-MM-DD hh:mm A') : '-'
                    if (response.data.rejectedBy !== null && response.data.status === 'Rejected') {
                        this.model.statusText = 'Rejected By'
                        this.model.statusTextTime = 'Rejected Time'
                        this.model.statusValue = response.data.rejectedBy !== null ? response.data.rejectedBy : '-'
                        this.model.statusTime = response.data.rejectedTime !== null ? this.$moment(response.data.rejectedTime).format('YYYY-MM-DD hh:mm A') : '-'
                    }
                    if (response.data.cancelTime !== null) {
                        this.model.statusTextTime = 'Canceled Time'
                        this.model.statusTime = response.data.cancelTime !== null ? this.$moment(response.data.cancelTime).format('YYYY-MM-DD hh:mm A') : '-'
                    }
                    this.purchaseRequisitionHistoryStatusList = []
                    if (response.data.purchaseRequisitionHistory !== null) {
                        response.data.purchaseRequisitionHistory.forEach(data => {
                            this.purchaseRequisitionHistoryStatusList.push(data)
                        })
                    }
                })
                .catch(error => {
                    this.isLoading = false
                    this.$store.dispatch('notification/error', error)
                })
            },
            enableEditing: function(){
                this.model.priceTemp = this.model.price;
                this.model.editing = true;
            },
            disableEditing: function(){
                this.model.priceTemp = null;
                this.model.editing = false;
            },
            saveEdit () {
                this.model.price = this.model.priceTemp;
                this.disableEditing();
            },
            showModal (type) {
                this.formData.note = null
                this.type = type
                this.$bvModal.show('bv-modal-example')
            },
            doChangeStatus (type) {
                this.isLoading = true
                this.$http.post(window.AppConfig.apiUrl + 'purchase-requisition-action', {
                    uuid: this.$route.params.uuid,
                    action: type,
                    price: this.model.price,
                    note: this.formData.note
                })
                .then(() => {
                    this.isLoading = false
                    this.formData.note = null
                    this.model.price = null
                    this.getDetail()
                    // this.getHistoryStatus()
                    this.$bvModal.hide('bv-modal-example')
                    if (type === 'reject') {
                        this.$store.dispatch('notification/success', 'Purchase requisition has been ' + type + 'ed')
                    } else {
                        this.$store.dispatch('notification/success', 'Purchase requisition has been ' + type + 'd')
                    }
                })
                .catch(error => {
                    this.isLoading = false
                    this.$store.dispatch('notification/error', error)
                });
            },
            formatPrice(value) {
                let val = (value/1).toFixed(2).replace(',', '.')
                return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")
            },
            getDateTime (value) {
                if (value !== null) {
                    return this.$moment(value).format('YYYY-MM-DD HH:mm A')
                } else {
                    return '-'
                }
            },
            goBack () {
                window.goBack(this)
            },
            getStatusColor (val) {
                switch (val) {
                case 'Approved':
                    return 'success'
                    // eslint-disable-next-line no-unreachable
                    break
                case 'Requested':
                    return 'info'
                    // eslint-disable-next-line no-unreachable
                    break

                case 'Rejected':
                    return 'danger'
                    // eslint-disable-next-line no-unreachable
                    break
                case 'Paid':
                    return 'primary'
                    // eslint-disable-next-line no-unreachable
                    break
                }
            },
            hasRole (name) {
              let temp = false
              name.forEach((key) => {
                if (this.$store.getters['account/accountData'].role == key){
                  temp = true
                }
              })
              return temp
            }
        }
    }
</script>